/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { PasswordInput as NativePasswordInput } from '@mantine/core';

// I18n
import { useTranslation } from 'react-i18next';

// Style
import classes from './PasswordInput.module.css';

// Icons
import { IconEye, IconEyeOff } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const PasswordInput = (props: {
	onClick?: () => void;
	id?: string;
	size?: string;
	radius?: string;
	label?: string;
	description?: string;
	placeholder?: string;
	variant?: string;
	fullWidth?: boolean;
	withAsterisk?: boolean;
	error?: any;
	disabled?: boolean;
	visibleFrom?: string;
	hiddenFrom?: string;
	value?: string;
	readOnly?: boolean;
	defaultVisible?: boolean;
}) => {
	const { t } = useTranslation();
	const { error, ...restProps } = props;

	/* ******************************** RENDERING ******************************* */
	return (
		<NativePasswordInput
			autoComplete="new-password"
			classNames={classes}
			error={t(error)}
			visibilityToggleIcon={({ reveal }) =>
				reveal ? (
					<IconEye strokeWidth={1.5} color="#8D8D8D" />
				) : (
					<IconEyeOff strokeWidth={1.5} color="#8D8D8D" />
				)
			}
			{...restProps}
		/>
	);
};
